export default __webpack_public_path__ + "static/media/sm2.c18b6d52.png";